import * as React from 'react';

import MixedSelectDropdown from 'components/inputs/mixed-select-dropdown/MixedSelectDropdown';

import type {
  Data,
  MixedSelectDropdownItem,
  SelectOption
} from 'types';

import './content-list-labeled-select.scss';

type Props = {
  label: string,
  options: Array<SelectOption>,
  value: string,
  onChange: (a: string) => void
};

const ContentListLabeledSelect = (
  {
    options,
    value,
    label,
    onChange
  }: Props
): JSX.Element => {
  const getDropdownItems = (): Array<MixedSelectDropdownItem> => (
    options.map(item => ({
      identifier: item.value,
      isDisabled: false,
      isSelected: value === item.value,
      label: item.label,
      value: item.value
    }))
  );

  const handleSortChange = (
    updatedItems: Array<MixedSelectDropdownItem>,
    data?: Data | null,
    selectedItem?: Partial<MixedSelectDropdownItem> | null
  ): void => (
    onChange(selectedItem?.identifier || updatedItems[0].identifier)
  );

  const dropdownItems = getDropdownItems();

  return (
    <div className="content-list-labeled-select">
      <div className="content-list-labeled-select__label">
        {label}
      </div>
      <MixedSelectDropdown
        key={`content-list-labeled-select__dropdown--${value}`}
        name="content-list-labeled-select__dropdown"
        items={dropdownItems}
        withSelectedInList
        className="content-list-labeled-select__dropdown"
        onItemsToggle={handleSortChange}
      />
    </div>
  );
};

export default ContentListLabeledSelect;
